<cb-dialog dialogHeading="Edit Consent Details">
    <form class="flex-col flex" #editConsentForm="ngForm">
        <cb-input
            type="text"
            label="Consent Number"
            name="consentNumber"
            [(ngModel)]="mappedItem.consentNumber"
            [softRequired]="true"
        ></cb-input>
        <cb-datepicker
            label="Consent Granted Date"
            name="consentGrantedDate"
            pickerType="calendar"
            [(ngModel)]="mappedItem.consentGrantedDate"
        ></cb-datepicker>
        <cb-datepicker
            label="Consent Expiry Date"
            name="consentExpiryDate"
            pickerType="calendar"
            [minDate]="minExpiryDate"
            [(ngModel)]="mappedItem.consentExpiryDate"
        ></cb-datepicker>
        @if (isNotAfterGrantedDate(mappedItem.consentExpiryDate)) {
            <span class="error-msg mat-caption cb-error">
                Consent Expiry Date must be after Consent Granted Date
            </span>
        }
        @if (isBuildingConsent) {
            <cb-datepicker
                label="CCC Expiry Date"
                name="codeOfComplianceExpiryDate"
                pickerType="calendar"
                [minDate]="minExpiryDate"
                [(ngModel)]="buildingConsent.codeOfComplianceExpiryDate"
            ></cb-datepicker>
            @if (isNotAfterGrantedDate(buildingConsent.codeOfComplianceExpiryDate)) {
                <span class="error-msg mat-caption cb-error">
                    CCC Expiry Date must be after Consent Granted Date
                </span>
            }
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="editConsentForm.invalid || editConsentForm.pristine || hasInvalidExpiryDates"
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
